import { BiltyFormat1, BiltyFormat2, BiltyFormat3 } from "BiltyFomates";
import { getBuiltyPrint, getInvoiceLrPodPrint, getMasterData, getPreviewInvoiceLrPod } from "_services";
import { CommonModal, CustomSelect } from "components";
import { UserContext } from "context";
import { API, AppConfig } from "lib";
import React, { useContext, useEffect, useRef, useState } from "react";
import moment from "moment";
import StorageService from "utils/StorageServices/StorageServices";
import Loading from "pages/Loading";
import { Images } from "constants";
import { StorageServices } from "utils";
import { changeDefaultStatusApi, getAllLrFormatebyBranch } from "_services/accountsServices/branchServices";
import AddLrFormatModal from "modals/AddLrFormatModal";
import LrSettingOffcanvas from "modals/LrSettingOffcanvas";
import toast from "react-hot-toast";
import ReactDOM from "react-dom";

const copies = [
    {
        label: "Original Copy",
        check: true,
        value: 1
    },
    {
        label: "Duplicate Copy",
        check: true,
        value: 2
    },
    {
        label: "Triplicate Copy",
        check: true,
        value: 3
    },
    {
        label: "Quadriate Copy",
        check: false,
        value: 4
    }
]

const InvoiceLrPodModal = (props) => {
    const { format } = props;
    const [loading, setLoading] = useState(false);
    const [loadingBilty, setLoadingBilty] = useState(false)
    let isToken = localStorage.getItem("token");
    const [state, setState] = useState({
        formate: "",
        page: "",
    });
    const [builtyFormatList, setBuiltyFormatList] = useState([])
    const [pageofPint, setPageOfPrint] = useState([])
    const [buityFormatePreview, setBuityFormatePreview] = useState('')
    const [isLoaddingPrint, setIsLoaddingPrint] = useState(false)
    const companyId = StorageServices.getCompanyId()
    const branchID = format?.originalData?.branch_id?._id // tripDetais?.branch_id?._id
    const [podPreviewData, setPodPreviewData] = useState([])
    const [showAddNewFormat, setShowAddNewFormat] = useState(false);
    const [form, setForm] = useState("")
    // ✅ isSelected: branch me already added formats track karne ke liye
    const [isSelected, setIsSelected] = useState([]);
    const [showLrSetting, setShowLrSetting] = useState(false)
    const hasSetDefaultRef = useRef(false);

    const [invoiceLrPod, setInvoiceLrPod] = useState({
        invoice_format: {},
        no_of_pages: { label: "Original Copy", check: true, value: 1 },
        layout: { label: 'Portrait', value: 'portrait' },
        pageSize: { label: 'A4', value: 'A4' },
    })

    const getBranchLrFormat = async (company_id, branch_id) => {
        const payload = { company_id, branch_id };
        try {
            const res = await getAllLrFormatebyBranch(payload);
            if (res?.responseCode === 200) {
                const formats = res?.data?.formats || [];
                if (formats.length <= 0) {
                    props?.closeModal()
                    props?.confirmBox()
                    return;
                }

                 setIsSelected(formats);
                const formattedList = formats.map((i) => ({
                    ...i,
                    label: i?.name,
                    value: i?.id,
                }));


                setBuiltyFormatList(formattedList);
                const defaultFormat = formattedList.find(f => f.is_default === 1);
                if (defaultFormat) {
                    let numberOfPages = defaultFormat?.copies?.length > 0 ?
                        defaultFormat?.copies?.map((el) => {
                            return {
                                ...el,
                                label: el?.name,
                            }
                        }) : []
                    setPageOfPrint(numberOfPages);
                    setInvoiceLrPod((s) => ({ ...s, invoice_format: defaultFormat, no_of_pages: numberOfPages[0] }))
                }
            }
        } catch (error) {
            console.error("Error in getBranchLrFormat:", error);
        }
    };


    const changeDefaultStatus = async (checkedValue, formatId) => {
        const payload = {
            company_id: companyId,
            branch_id: branchID,
            format_id: formatId,
            is_default: checkedValue,
        };
        try {
            const res = await changeDefaultStatusApi(payload);
            if (res?.responseCode !== 200) {
                toast.error(res?.responseMessage || "Failed to update default status.");
            }
        } catch (error) {
            toast.error(error?.message || "Something went wrong.");
        } finally {
            getBranchLrFormat(companyId, branchID);
            setShowAddNewFormat(false)
        }
    };

    const getBuiltyPrintapi = async (formatDetails) => {
        console.log(formatDetails)
        setLoadingBilty(true)
        try {
            const formate = {
                lr_with_pod: formatDetails?.lr_with_pod,
                no_of_pages: invoiceLrPod?.no_of_pages?.value,
                layout: invoiceLrPod?.layout?.value,
                pageSize: invoiceLrPod?.pageSize?.value,
                trip_id: formatDetails?.originalData?.trip_id?._id || "",
                lr_id: formatDetails?.lr_id || "",
                company_id: StorageService?.getCompanyId() || "",
                invoice_format: invoiceLrPod?.invoice_format?.value
            }
            const res = await getInvoiceLrPodPrint(formate);
            setBuityFormatePreview(res)
            if (res) {
                setLoadingBilty(false)
            }
        } catch (error) {
            console.log(error);
        }
    };

    const getPreviewInvoice = async (formatDetails) => {
        console.log(formatDetails)
        setLoadingBilty(true)
        try {
            const formate = {
                lr_with_pod: formatDetails?.lr_with_pod,
                no_of_pages: invoiceLrPod?.no_of_pages?.value,
                layout: invoiceLrPod?.layout?.value,
                pageSize: invoiceLrPod?.pageSize?.value,
                trip_id: formatDetails?.originalData?.trip_id?._id || "",
                lr_id: formatDetails?.lr_id || "",
                company_id: StorageService?.getCompanyId(),
                invoice_format: invoiceLrPod?.invoice_format?.value
            }
            const res = await getPreviewInvoiceLrPod(formate);
            if (res?.responseCode === 200) {
                setPodPreviewData(res?.data)
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        if (builtyFormatList?.length > 0 && format?.lr_id) {
            getBuiltyPrintapi(format);
            if (format?.lr_with_pod === 1) {
                getPreviewInvoice(format);
            }
        }
    }, [builtyFormatList, format, invoiceLrPod])

    useEffect(() => {
        if (companyId && branchID) {
            getBranchLrFormat(companyId, branchID)
        }
    }, [companyId, branchID])

    const handlePrintDownload = async () => {
        try {
            const payload = {
                invoice_format: invoiceLrPod?.invoice_format?.value,
                no_of_pages: invoiceLrPod?.no_of_pages?.value,
                company_id: StorageService?.getCompanyId(),
                trip_id: format?.originalData?.trip_id?._id || "",
                lr_id: format?.lr_id,
                lr_with_pod: format?.lr_with_pod,
            }
            setLoading(true);
            const response = await fetch(`${AppConfig.api_baseurl}${API.DOWNLOAD_N_PRINT_INVOICE_LR_POD}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Token': `${isToken}`,
                },
                body: JSON.stringify(payload)
            });

            const blob = await response.blob();
            const blobURL = URL.createObjectURL(blob);

            const iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            iframe.src = blobURL;

            iframe.onload = function () {
                setTimeout(() => {
                    iframe.contentWindow?.focus();
                    iframe.contentWindow?.print();
                }, 300);
            };

            document.body.appendChild(iframe);
            setLoading(false);
        } catch (error) {
            console.error('Print download failed:', error);
            setLoading(false);
        }
    };

    const handleDownload = async () => {
        try {
            const payload = {
                invoice_format: invoiceLrPod?.invoice_format?.value,
                no_of_pages: invoiceLrPod?.no_of_pages?.value,
                company_id: StorageService?.getCompanyId(),
                trip_id: format?.originalData?.trip_id?._id || "",
                lr_id: format?.lr_id,
                lr_with_pod: format?.lr_with_pod,
                layout: invoiceLrPod?.layout?.value,
                pageSize: invoiceLrPod?.pageSize?.value,
            }
            setIsLoaddingPrint(true)
            const response = await fetch(`${AppConfig.api_baseurl}${API.DOWNLOAD_N_PRINT_INVOICE_LR_POD}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Token': `${isToken}`,
                },
                body: JSON.stringify(payload)
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `Format-${invoiceLrPod?.invoice_format?.value}/${moment(new Date()).format("D MMM YYYY")}.pdf`;
            document.body.appendChild(a);
            a.click();
            a.remove();
            setIsLoaddingPrint(false)
        } catch (error) {
            setIsLoaddingPrint(false)
        }
    }

    const formatePrpsTrip = {
        buityFormatePreview: buityFormatePreview,
        showPodPreview: true,
        podPreviewData: podPreviewData
    };

    const propsBuiltyPrint = {
        ...props,
        // onSubmit:handlePrint
        onPrint: handleDownload,
        onSubmit: handlePrintDownload,
        isLoadding: loading,
        disabled: loading || loadingBilty || isLoaddingPrint,
        isLoaddingPrint: isLoaddingPrint,
        modalZIndexFormat:(showLrSetting || showAddNewFormat) && 1055
    };

    const onhandleSelect = async (item, name) => {
        const stateObj = { ...invoiceLrPod, [name]: item };
        if (name === 'invoice_format') {
            let numberOfPages = item?.copies?.length > 0 ?
                item?.copies?.map((el) => {
                    return {
                        ...el,
                        label: el?.name,
                    }
                }) : []
            setPageOfPrint(numberOfPages);
            stateObj['no_of_pages'] = numberOfPages[0]
        }
        setInvoiceLrPod(stateObj);
    };

    return (
        <>
            <CommonModal {...propsBuiltyPrint}>
                <div className="bltyPrint_body">
                    <div className="bltyPrt_viewPage_bx" id="print-area">

                        {!loadingBilty ? <BiltyFormat3 {...formatePrpsTrip} /> : <div colSpan="100%" style={{ textAlign: "center", margin: "0 22rem", display: "flex", alignItems: "center", justifyContent: "center", height: "50vh" }}>
                            <img className="_loadWidth" style={{ width: "150px", color: "f2f2f2" }} src={Images.LOADINGTRUCK} alt="" />
                        </div>}
                    </div>

                    <div className="_prtRight_selctors">
                        <div>
                            <CustomSelect
                                label="Bilty Format"
                                options={builtyFormatList}
                                value={invoiceLrPod?.invoice_format}
                                onSelect={(data) => onhandleSelect(data, 'invoice_format')}
                                isAddButton={true}
                                addButtonAction={() => setShowAddNewFormat(true)}
                                onEditValue={(data) => {
                                    console.log("data", data)
                                    setShowLrSetting(data)
                                    setForm(data)
                                }}
                            />
                        </div>

                        <div>
                            <CustomSelect
                                label="Number of Pages"
                                options={pageofPint}
                                value={invoiceLrPod?.no_of_pages}
                                onSelect={(data) => onhandleSelect(data, 'no_of_pages')}
                            />
                        </div>

                        <div>
                            <CustomSelect
                                label="Layout"
                                options={[{ label: 'Landscape', value: 'landscape' }, { label: 'Portrait', value: 'portrait' }]}
                                value={invoiceLrPod?.layout}
                                onSelect={(data) => onhandleSelect(data, 'layout')}
                            />
                        </div>

                        <div>
                            <CustomSelect
                                label="Page size"
                                options={[{ label: 'A4', value: 'A4' }, { label: 'A5', value: 'A5' }]}
                                value={invoiceLrPod.pageSize}
                                onSelect={(data) => onhandleSelect(data, 'pageSize')}
                            />
                        </div>
                    </div>
                </div>
            </CommonModal>

            {/* ✅ AddLrFormatModal — sahi props ke saath */}
            // अब करो:
            {showAddNewFormat && ReactDOM.createPortal(
                <AddLrFormatModal
                    show={showAddNewFormat}
                    onClose={() => setShowAddNewFormat(false)}
                    companyId={companyId}
                    branchId={branchID}
                    addedFormats={isSelected}
                    onFormatAdded={({ localAdded, frWithoutImage }) => {
                        setIsSelected(localAdded);
                        changeDefaultStatus(1, frWithoutImage?._id);
                    }}
                />,
                document.body  // ✅ body में render होगा, modal के DOM के बाहर
            )}

            {showLrSetting && ReactDOM.createPortal(
                <LrSettingOffcanvas
                    show={showLrSetting}
                    onClose={() => setShowLrSetting(false)}
                    form={form}
                    setForm={setForm}
                    companyId={companyId}
                    branchId={branchID}
                    onUpdateSuccess={() => getBranchLrFormat(companyId, branchID)}
                />,
                document.body  // ✅ body में render होगा
            )}

        </>
    );
};

export default InvoiceLrPodModal;
